// import case names
import { get, filter } from 'lodash';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get a global redux store ( creates empty store if not already created )
const store = getStore();

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { getCallControlActionsResolver } from 'resolvers/getCallControlActions';
 */
export const getCallControlActionsResolver = ( actions = [] ) => {

    // check if the call is transferred
    const isCallTransferred = get( store.getState()[ REDUCER.CALL_STATE ], 'callTransferred', false );

    if( isCallTransferred ) {

        return filter( actions, action => {
            return 'transferCall' !== action.name;
        } );
    } else {
        
        return filter( actions, action => {
            return 'retrieveCall' !== action.name;
        } );
    }
};
